// 印度国际化验证
/** 校验 */
let INcheckRealname = function (val) {
    // let reg = /^[a-zA-Z\u4e00-\u9fa5]{2,10}$/
    // let reg = /^[\u4e00-\u9fa5]{2,20}$/
    if (val === '') {
      return 'form.checkRealname';
    }
    // else if (!reg.test(val)) {
    //   return '真实姓名格式错误';
    // }
    return '';
};
let Realname11IC = function (val) {    // [0-9a-zA-Z]
  let reg = /^[a-zA-Z]\s{0,1}([\w]{1,}\s{1})*\w{1,}$/
    // let reg = /^[\u4e00-\u9fa5]{2,20}$/
    if (val === '') {
      return 'form.checkRealname';
    }else if (!reg.test(val)) {
      return 'createdDislaog.prove';
    }
    return '';
};
/** 校验注册密码 */
let checkRegisterPassword = function (val) {
  let reg = /^[A-Za-z0-9]{6,12}$/;
  if (val === '') {
    return 'form.checkRegisterPassword1';   //请输入密码
  }
  else if (!reg.test(val)) {
    return 'form.checkRegisterPassword2' //密码由6-12位组成,需包含字母、数字
  }
  return '';
};
/** 校验身份证 */
let checkCard = function (val) {
    let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
    if (val === '') {
      return 'form.checkCard1'; //请输入身份证号
    } else if (!reg.test(val)) {
      return 'form.checkCard2';  //身份证格式错误
    }
    return '';
};
/** 校验邮箱 */
let checkEmail = function (val) {
    let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
    if (val === '') {
      return 'form.checkEmail1'; //请输入邮箱
    } else if (!reg.test(val)) {
      return 'form.checkEmail2'; //邮箱格式错误
    }
    return '';
};
/**校验手机号*/
let checkPhone = function (val) {
    // let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    let reg = /^\d{10}$/;
    if(val===''){
      return 'form.checkPhone1' //请输入手机号
    } else if(!reg.test(val)){
      return 'form.checkPhone2' //请输入正确的手机号
    }
    return ''
};
/** 校验密码 */
let checkPassword = function (val) {
    // let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
    if (val === '') {
        return 'form.checkPassword'; //请输入密码
    }
    // else if (!reg.test(val)) {
    //   return '密码由6-12位组成'
    // }
    return '';
};
/** 校验确认密码 */
let checkConfirm = function (p1, p2) {
    if (p2 === '') {
        return 'form.checkConfirm1';  //请再次输入密码
    } else if (p2 !== p1) {
        return 'form.checkConfirm2';  //两次密码输入不一致
    }
    return '';
};
/** 在个人中心修改登录密码 */
let mycenterLoginchange = function (p1, p2) {
    let reg = /^[A-Za-z0-9]{6,12}$/;
    if (p2 === '') {
        return 'form.checkConfirm1';  //请再次输入密码
    } else if (p2 !== p1) {
        return 'form.checkConfirm2';  //两次密码输入不一致
    }else if (!reg.test(p1)) {
      return 'form.checkRegisterPassword2' //密码由6-12位组成,需包含字母、数字
    }
    return '';
  
};
/** 校验原密码确认密码 */
let checkConfirms = function (p1, p2) {
    if (p2 === p1) {
        return 'form.checkConfirms'; //新密码与原密码相同
    }
    return '';
};
/** 提款密码 */
let checkWithdraw = function (val) {

    // let reg = /^(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,15}$/;
    // let reg = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{8,15}$/;
    if (val === '') {
      return 'form.checkWithdraw';
    }
    // else if (!reg.test(val)) {
    //   return '提款密码由8-15位大小写英文字母、0-9组成'
    // }
    return '';
};
/**校验验证码*/
let checkVerifiCode = function (val) {

    let reg = /^[0-9]{4,8}$/;
    if (val === '') {
      return 'form.checkVerifiCode1'; //验证码不能为空
    } else if (!reg.test(val)) {
      return 'form.checkVerifiCode2'; //验证码格式错误
    }
    return ''
};
/** 校验金额 */
let checkMoney = function (val) {
  // let reg = /(^[1-9]([0-9]+)?(\.[0-9]*)?$)|(^(0){1}$)|(^(0){1}\.[0-9]+$)/;
  let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
  if (val === '') {
    return 'form.checkMoney1';
  } else if (!reg.test(val)) {
    return 'form.checkMoney2';
  }else if(val == 0){
    return 'form.checkMoney3';
  }
  return ''
};
/** 校验 */
let checkRealname = function (val) {
  // let reg = /^[a-zA-Z\u4e00-\u9fa5]{2,10}$/
  // let reg = /^[\u4e00-\u9fa5]{2,20}$/
  if (val === '') {
    return 'form.checkRealname';
  }
  // else if (!reg.test(val)) {
  //   return '真实姓名格式错误';
  // }
  return '';
};
/**校验银行卡*/
let checkBankNumber = function (val) {

  let reg = /^\d{6,22}$/;
  if (val === '') {
    return 'form.checkBankNumber1';
  } else if (!reg.test(val)) {
    return 'form.checkBankNumber2';
  }
  return ''
};
/** 校验支行*/
let checkBranch = function (val) {
  // let reg = /^[a-zA-Z\u4e00-\u9fa5]{1,20}$/
  if (val === '') {
    return 'form.checkBranch';
  }
  // else if (!reg.test(val)) {
  //   return '开户支行格式错误';
  // }
  return '';
};
/** 校验银行类型和银行名称*/
let checkBankName = function(val){

  if(val === ''){
    return 'form.checkBankName'
  }
  return ''
}
/** 校验整数 */
let checkNumber = function (val) {
  let reg = /^\+?[1-9][0-9]*$/;
  if (val === '') {
    return 'form.checkNumber1';
  } else if (!reg.test(val)) {
    return 'form.checkNumber2';
  }else if(val == 0){
    return 'form.checkNumber3';
  }
  return ''
};
/** 校验支付金额*/ 
let checkPayMoney = function(val,min,max){
  let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
  if (val === '') {
    // return '请输入金额';
    return 'form.checkPayMoney1';
  } else if (!reg.test(val)) {
    // return '金额格式错误';
    return 'form.checkPayMoney2';
  }else if(!(min <= val && val <= max)){
    // return `存款限额：${min}-${max}INR`;
    return 'form.checkPayMoney3';
  }
  return ''
}
let checkUSDTPayMoney = function(val,min,max){
  let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
  if (val === '') {
    // return '请输入金额';
    return 'form.checkPayMoney4';
  } else if (!reg.test(val)) {
    // return '金额格式错误';
    return 'form.checkPayMoney2';
  }else if(!(min <= val && val <= max)){
    // return `存款限额：${min}-${max}INR`;
    return 'form.checkPayMoney3';
  }
  return ''
}
export default {
  Realname11IC,
    INcheckRealname,
    checkCard,
    checkEmail,
    checkPhone,
    checkPassword,
    checkConfirm,
    checkConfirms,
    checkWithdraw,
    checkVerifiCode,
    checkMoney,
    checkRealname,
    checkBankNumber,
    checkBranch,
    checkBankName,
    checkRegisterPassword,
    checkNumber,
    checkPayMoney,
    checkUSDTPayMoney,
    mycenterLoginchange
};


// WEBPACK FOOTER //
// ./src/common/form/INindex.js